import { FC, SVGProps } from "react";

const CheckTimeIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentcolor" {...props}>
      <path
        d="M9 18V16H16V2H9V0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H9ZM7 14L5.625 12.55L8.175 10H0V8H8.175L5.625 5.45L7 4L12 9L7 14Z"
      />
    </svg>
  );
};

export default CheckTimeIcon;
